export enum ISSUING_TRANSACTION_TYPE {
  CAPTURE = 'CAPTURE',
  REFUND = 'REFUND',
}

export type IssuingTransactionType =
  (typeof ISSUING_TRANSACTION_TYPE)[keyof typeof ISSUING_TRANSACTION_TYPE];
